// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__1kNFS","container":"styles_container__1X2ij","title":"styles_title__3_Ple","wrapper":"styles_wrapper__9KuMm","answer":"styles_answer__gFliF"};